const getSocketIo = () => import('socket.io-client')

/* @ngInject */
function socketService (CONSTANTS, $rootScope, $cookies) {
  const socket = {}

  var service = {
    connectSocket,
    disconnectSocket,
    registerEvent,
    emit,
    broadcast,
    isConnected
  }
  return service

  function getNamespaceUrl (namespace = 'Workflow') {
    return `/socket/${namespace}`
  }

  function connectSocket (namespace, params = {}) {
    if (!CONSTANTS.IS_SOCKET_ENABLED) {
      return
    }

    const socketParams = {
      ...params,
      query: params.query || {},
      reconnectionAttempts: 5,
      transports: ['websocket'],
      forceNew: true
    }
    const jwt = $cookies.get('jwt')
    let url = CONSTANTS.URL_BACKEND

    if (namespace) {
      url = `${url}/socket/${namespace}`
    }

    if (jwt) {
      socketParams.query.jwt = jwt
    }

    getSocketIo().then((io) => {
      const socketConnection = io.default(url, socketParams)
      socket[socketConnection.nsp] = socketConnection

      connectEvent(namespace)
      error(namespace)
    })
  }

  function isConnected (namespace) {
    const url = getNamespaceUrl(namespace)
    return Boolean(socket[url]?.connected)
  }

  function disconnectSocket (namespace) {
    const url = getNamespaceUrl(namespace)
    if (socket[url]) {
      socket[url].disconnect(true)
    }
  }

  function registerEvent (eventName, callback, namespace) {
    const url = getNamespaceUrl(namespace)
    if (!socket[url]) {
      return
    }

    socket[url].on(eventName, callback)
  }

  function emit (eventName, data, namespace) {
    const url = getNamespaceUrl(namespace)
    if (!socket[url]) {
      return
    }

    socket[url].emit(eventName, data)
  }

  function broadcast (eventName, data, namespace) {
    const url = getNamespaceUrl(namespace)
    if (!socket[url]) {
      return
    }

    socket[url].broadcast.emit(eventName, data)
  }

  function connectEvent (namespace) {
    const url = getNamespaceUrl(namespace)
    if (!socket[url]) {
      return
    }

    socket[url].on('connect', () => {
      $rootScope.$emit(`socket-connected-successfully-${namespace}`)
    })
  }

  function error (namespace) {
    const url = getNamespaceUrl(namespace)
    if (!socket[url]) {
      return
    }

    socket[url].on('error', (error) => {
      console.log(error)
    })
  }
}

export { socketService }
